import React from 'react';
import { Box, Typography } from '@mui/material';

/** Flat titled card used for each block of the candidate profile. */
function CandidateSection({ title, children, sx }) {
    return (
        <Box
            component="section"
            sx={{
                p: { xs: 2.5, md: 3 },
                mb: 2,
                bgcolor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: '14px',
                ...sx,
            }}
        >
            <Typography variant="h6" fontWeight={700} sx={{ mb: 2, fontSize: '1.05rem' }}>
                {title}
            </Typography>
            {children}
        </Box>
    );
}

export default CandidateSection;
